import { Injectable, Inject } from '@angular/core';
import { downgradeToAJSService } from 'ib-web-commons/utils';
import { AJSGiftCardsCurrencyService, GiftCardsCurrencyServiceType } from '@shared/services/upgrades/ib-gift-cards-currency-service-bridge.service';
import { CardType, CardTypes } from '@src/app/core/models/generic-models/generic-models';

@Injectable({
    providedIn: 'root'
})
export class GiftCardsImportModelService {

    constructor (
        @Inject(AJSGiftCardsCurrencyService) private currencyService: GiftCardsCurrencyServiceType
    ) {}

    checkIfDecimalIsZero (amountToCheckDecimals: string): string | null {
        if (!amountToCheckDecimals) {
            return null;
        }
        return amountToCheckDecimals.replace(',00', '').replace('.00', '');
    }

    setAvailabilityData (type: CardType, data: Types.AvailabilityGiftCards ) {

        const arrayMax: number[] = [];
        const fixedPricesByType = data[type.dataPoint];
        fixedPricesByType.forEach((fixedPriceByType, index) => {
            fixedPriceByType.name = `radio_${fixedPriceByType.amount}_${index}${type.subfix}`;
            fixedPriceByType.price = this.currencyService.formatPrice(data.currency, fixedPriceByType.amount, false, false, true);
            if (fixedPriceByType.discount) {
                fixedPriceByType.discount.price = this.checkIfDecimalIsZero(this.currencyService.formatPrice(data.currency, fixedPriceByType.discount.amount, true));
                arrayMax.push(fixedPriceByType.discount.percentage);
                fixedPriceByType.hasDiscount = true;
            }
        });
    }
    transformInfo (data: Types.AvailabilityGiftCards): any {
        const arrayMax: number[] = [];
        const code = data.currency.code;
        data.currency = this.currencyService.getCurrencyObject(data.currency);
        data.currency.code = code;

        const cardTypes: CardTypes = [
            {
                dataPoint: 'groupFixedPrices',
                subfix: '_group'
            },
            {
                dataPoint: 'fixedPrices',
                subfix: ''
            }
        ];

        cardTypes.forEach((cardType) => {
            this.setAvailabilityData(cardType, data);
            
        });

        for (let i = 0; i <= 2; i++) {
            const dataPoint = i === 0 ? 'groupFixedPrices' : 'fixedPrices';
            const nameForGroup = dataPoint === 'groupFixedPrices' ? '_group' : '';
            let hasDiscount = false;

            // data[dataPoint]?.forEach((datatype: any, index: number) => {
            //     datatype.name = `radio_${datatype.amount}_${index}${nameForGroup}`;
            //     datatype.price = this.currencyService.formatPrice(data.currency, datatype.amount, false, false, true);
            //     if (datatype.discount) {
            //         datatype.discount.price = this.checkIfDecimalIsZero(this.currencyService.formatPrice(data.currency, datatype.discount.amount, true));
            //         arrayMax.push(datatype.discount.percentage);
            //         hasDiscount = true;
            //     }
            // });

            if (hasDiscount) {
                data[dataPoint as any].hasDiscount = true;
            }
        }

        arrayMax.push(data?.customPrice?.percentage);
        data.maxPercentage = Math.max(...arrayMax);
        return data;
    }
}

// Downgrade el servicio para AngularJS
downgradeToAJSService('GiftCardsImportModelService', GiftCardsImportModelService, 'ib-gift-cards-service-module');
